import { watchEffect } from 'vue'

const SITE_NAME = 'Bimdrop'
const SITE_ORIGIN = 'https://bimdrop.app'
const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/og-image.png?v=2`

export interface SeoOptions {
  title?: string
  description?: string
  path?: string
  image?: string
  noindex?: boolean
}

function upsertMeta(attr: 'name' | 'property', key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', value)
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

export function useSeo(getOptions: () => SeoOptions) {
  watchEffect(() => {
    const opts = getOptions()
    const title = opts.title ? `${opts.title} — ${SITE_NAME}` : SITE_NAME
    const description = opts.description ?? ''
    const url = opts.path ? `${SITE_ORIGIN}${opts.path}` : SITE_ORIGIN + '/'
    const image = opts.image ?? DEFAULT_OG_IMAGE

    document.title = title
    if (description) upsertMeta('name', 'description', description)

    upsertMeta('name', 'robots', opts.noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large')

    upsertCanonical(url)

    upsertMeta('property', 'og:title', title)
    if (description) upsertMeta('property', 'og:description', description)
    upsertMeta('property', 'og:url', url)
    upsertMeta('property', 'og:image', image)

    upsertMeta('name', 'twitter:title', title)
    if (description) upsertMeta('name', 'twitter:description', description)
    upsertMeta('name', 'twitter:image', image)
  })
}
